export default ({ $auth, isIos, isAndroid, redirect }) => {
  const isLoggedIn = $auth.$state.user && $auth.$state.user.id
  if ((isIos || isAndroid) && !isLoggedIn) {
    return redirect('/')
  }
}
